import {
    Avatar,
    Button,
    Card,
    Container,
    Divider,
    Flex,
    Group,
    SimpleGrid,
    Text,
} from "@mantine/core";
import {
    IconEdit,
    IconLock,
    IconMail,
    IconPhone,
    IconUser,
} from "@tabler/icons";
import { useEffect, useState } from "react";
import ChangePasswordModal from "./changePassword";
import EditProfileModal from "./editProfile";

const ProfilePage = () => {
  const [user, setUser] = useState({});
  const [editProfileOpen, setEditProfileOpen] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  // Load user data on page load
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUser(userData);
  }, []);

  // Callback to update user details after successful edit
  const handleUserUpdate = (updatedUser) => {
    setUser(updatedUser);
  };

  return (
    <Container size="sm" mt="lg">
      <Card
        shadow="xl"
        padding="lg"
        radius="md"
        style={{ backgroundColor: "#fff", border: "1px solid #eee" }}
      >
        <Group position="center" spacing="xs" direction="column">
          <Avatar
            size={100}
            radius="50%"
            color="orange"
            style={{ fontSize: 36, fontWeight: "bold" }}
            src={user?.profile_image} // Show profile image if exists
          >
            {!user?.profile_image && user?.name?.charAt(0)?.toUpperCase()}
          </Avatar>
          <Text size="xl" weight={700}>
            {user?.name ?? "User"}
          </Text>
        </Group>

        <Divider my="md" />

        <SimpleGrid cols={1} spacing="sm">
          <Group>
            <IconUser size={20} />
            <Text weight={500}>Name:</Text>
            <Text>{user?.name}</Text>
          </Group>
          <Group>
            <IconMail size={20} />
            <Text weight={500}>Email:</Text>
            <Text>{user?.email}</Text>
          </Group>
          <Group>
            <IconPhone size={20} />
            <Text weight={500}>Phone:</Text>
            <Text>{user?.phone || "Not Provided"}</Text>
          </Group>
        </SimpleGrid>

        <Divider my="md" />

        <Flex justify="center" gap="md">
          <Button
            variant="filled"
            style={{
              backgroundColor: "#FF6A00",
              color: "#FFFFFF",
            }}
            onClick={() => setEditProfileOpen(true)}
            leftIcon={<IconEdit size={16} />}
          >
            Edit Profile
          </Button>
          <Button
            variant="filled"
            style={{
              backgroundColor: "#FF6A00",
              color: "#FFFFFF",
            }}
            onClick={() => setChangePasswordOpen(true)}
            leftIcon={<IconLock size={16} />}
          >
            Change Password
          </Button>
        </Flex>
      </Card>

      {/* Modals */}
      <EditProfileModal
        opened={editProfileOpen}
        onClose={() => setEditProfileOpen(false)}
        user={user}
        onUserUpdate={handleUserUpdate} // ✅ pass callback here
      />

      <ChangePasswordModal
        opened={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
      />
    </Container>
  );
};

export default ProfilePage;
